import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../services/api";
import "../style.css";

export default function Dashboard() {
  const [stats, setStats] = useState({ blogs: 0, categories: 0 });

  useEffect(() => {
    async function load() {
      const [b, c] = await Promise.all([
        api.get("/blogs?limit=1"),
        api.get("/categories")
      ]);

      setStats({
        blogs: b.data?.pagination?.total || 0,
        categories: c.data?.data?.length || 0
      });
    }

    load().catch(() => {});
  }, []);

  return (
    <Layout>
      <h2>Dashboard</h2>
      <p className="muted">
        Manage blogs, categories, SEO fields, OG toggle, uploads, search & pagination.
      </p>

      <div className="row">
        <div className="card" style={{ padding: 16 }}>
          <div className="muted">Total Blogs</div>
          <div style={{ fontSize: 28, fontWeight: 900 }}>{stats.blogs}</div>
        </div>

        <div className="card" style={{ padding: 16 }}>
          <div className="muted">Total Categories</div>
          <div style={{ fontSize: 28, fontWeight: 900 }}>{stats.categories}</div>
        </div>
      </div>
    </Layout>
  );
}
